<template>
  <div class="home">
    <div class="container-fluid">
      <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-xl-3">
              <router-link class="card box22 cursor" to="/">
                  <div class="card-body" style="padding:0px;">
                      <img src="../assets/img/school.jpg" width="100%">
                      <div class="card-img-overlay2">
                          <span class="card-img-title" style="margin-top:8px;margin-left:8px;">Schoolで探す</span>
                      </div>
                  </div>
              </router-link>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-xl-3">
              <router-link class="card box22 cursor" to="/career">
                  <div class="card-body" style="padding:0px;">
                      <img src="../assets/img/career.jpg" width="100%">
                      <div class="card-img-overlay2">
                          <span class="card-img-title" style="margin-top:8px;margin-left:8px;">Careerで探す</span>
                      </div>
                  </div>
              </router-link>
          </div>
          <!-- <div class="col-12 col-sm-6 col-md-3">
              <router-link class="card box22 cursor" to="/question">
                  <div class="card-body" style="padding:0px;">
                      <img src="../assets/img/dummy01.png" width="100%">
                      <div class="card-img-overlay2">
                          <span class="card-img-title" style="margin-top:8px;margin-left:8px;">Question<span class="d-none d-sm-inline d-md-none d-xl-inline">で探す</span></span>
                      </div>
                  </div>
              </router-link>
          </div> -->
          <div class="col-12 col-sm-6 col-md-4 col-xl-3">
              <a class="card box22 cursor" href="https://pre.gokakuessay.com/">
                  <div class="card-body" style="padding:0px;">
                      <img src="../assets/img/essay.jpg" width="100%">
                      <div class="card-img-overlay2">
                          <span class="card-img-title" style="margin-top:8px;margin-left:8px;"><span class="d-md-none d-lg-inline">エッセイを</span>新規登録</span>
                      </div>
                  </div>
              </a>
          </div>
      </div>
      <router-view/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'home',
  components: {
  },
}
</script>

<style scoped>
.card-img-overlay2 {
    position: absolute;
    /* top: 0; */
    right: 0;
    bottom: 0;
    /* left: 0; */
    padding: 10px 0px;
    font-size: 1.2rem;
    /* font-weight: bold; */
    color: white;
}

span.card-img-title {
    font-size: 1.8rem;
    color: white;
    background-color: rgba(0,0,0,.75);
    padding: 2px 10px;
    border-radius: .15rem;
}

@media (max-width: 575.98px) {
  .box22 {
    padding:0;
    margin:10px 0px;
    background:#f4f4f4;
    border:none;
    border-left:solid 6px #5bb7ae;
    box-shadow:0px 2px 3px rgba(0, 0, 0, 0.33);
    cursor: pointer;
  }
}

@media (min-width: 576px) {
  .box22 {
    padding:0;
    margin:20px;
    background:#f4f4f4;
    border:none;
    border-left:solid 6px #5bb7ae;
    box-shadow:0px 2px 3px rgba(0, 0, 0, 0.33);
    cursor: pointer;
  }
}
</style>
